import React, { useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { resetPassword } from '../services/api';
import Navbar from '../components/Navbar';
import { useTheme } from '../context/ThemeContext';
import useWindowSize from '../hooks/useWindowSize';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { colors } = useTheme();
  const { width } = useWindowSize();
  const isMobile = width < 768;

  const handleSubmit = async () => {
    setError('');
    if (!newPassword || !confirmPassword) return setError('Rellena todos los campos');
    if (newPassword.length < 6) return setError('La contraseña debe tener al menos 6 caracteres');
    if (newPassword !== confirmPassword) return setError('Las contraseñas no coinciden');

    setLoading(true);
    try {
      await resetPassword({ token, newPassword });
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al restablecer la contraseña');
    }
    setLoading(false);
  };

  if (!token) {
    return (
      <div style={{ minHeight: '100vh', backgroundColor: colors.bg }}>
        <Navbar />
        <div style={{ textAlign: 'center', padding: '4rem 2rem' }}>
          <p style={{ color: '#ff4444', marginBottom: '1rem', fontSize: '0.9rem' }}>Enlace no válido. Solicita uno nuevo desde la página de inicio de sesión.</p>
          <Link to="/forgot-password" style={{ color: colors.accent, textDecoration: 'none', fontWeight: 'bold' }}>Solicitar enlace</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: colors.bg }}>
      <Navbar />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: isMobile ? '2rem 1rem' : '4rem 2rem' }}>
        <div style={{ width: '100%', maxWidth: '420px' }}>
          <h1 style={{ color: colors.text, fontSize: isMobile ? '1.6rem' : '1.8rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>Nueva contraseña</h1>
          <p style={{ color: colors.textSecondary, fontSize: '0.9rem', marginBottom: '2rem' }}>Elige una nueva contraseña para tu cuenta.</p>

          {success ? (
            <div style={{ backgroundColor: '#00cc6622', border: '1px solid #00cc66', color: '#00cc66', padding: '1rem', borderRadius: '8px', fontSize: '0.9rem' }}>
              Contraseña restablecida correctamente. Redirigiendo al inicio de sesión...
            </div>
          ) : (
            <>
              {error && <div style={{ backgroundColor: '#ff444422', border: '1px solid #ff4444', color: '#ff4444', padding: '0.8rem 1rem', borderRadius: '8px', marginBottom: '1.5rem', fontSize: '0.85rem' }}>{error}</div>}

              <div style={{ marginBottom: '1rem' }}>
                <label style={{ color: colors.textSecondary, fontSize: '0.85rem', display: 'block', marginBottom: '0.4rem' }}>Nueva contraseña</label>
                <div style={{ position: 'relative' }}>
                  <input
                    style={{ width: '100%', backgroundColor: colors.inputBg, border: `1px solid ${colors.border}`, borderRadius: '8px', padding: '0.8rem 3rem 0.8rem 1rem', color: colors.text, fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box' }}
                    type={showPassword ? 'text' : 'password'}
                    placeholder="••••••••"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <button type="button" onClick={() => setShowPassword(v => !v)} style={{ position: 'absolute', right: '0.8rem', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: colors.textSecondary, display: 'flex', alignItems: 'center', padding: 0 }}>
                    {showPassword ? <VisibilityOffIcon style={{ fontSize: 20 }} /> : <VisibilityIcon style={{ fontSize: 20 }} />}
                  </button>
                </div>
              </div>

              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ color: colors.textSecondary, fontSize: '0.85rem', display: 'block', marginBottom: '0.4rem' }}>Confirmar contraseña</label>
                <input
                  style={{ width: '100%', backgroundColor: colors.inputBg, border: `1px solid ${colors.border}`, borderRadius: '8px', padding: '0.8rem 1rem', color: colors.text, fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box' }}
                  type={showPassword ? 'text' : 'password'}
                  placeholder="••••••••"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                />
              </div>

              <button
                style={{ backgroundColor: colors.accent, color: colors.accentText, border: 'none', padding: '0.9rem', borderRadius: isMobile ? '4px' : '25px', cursor: 'pointer', fontWeight: 'bold', fontSize: '1rem', width: '100%', textTransform: isMobile ? 'uppercase' : 'none', letterSpacing: isMobile ? '0.05em' : 'normal' }}
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? 'Guardando...' : 'Restablecer contraseña'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;